import { Text } from '@dixa/lib-shared-habla';

import { ConversationAutomationAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughIntentDetectionProps = {
  readonly node: ConversationAutomationAuditLogEntry<'AUTOMATION_INTENT_DETECTION_NODE_VISITED'>;
};

export function RoutedThroughIntentDetection({
  node,
}: RoutedThroughIntentDetectionProps): JSX.Element {
  const matchedIntent = node.intents.find(
    (intent) => intent.id === node.matching_intent_id,
  );

  const paragraphStyle = node.skipped_due_to_quota
    ? { textDecoration: 'line-through' }
    : {};

  return (
    <Text.Paragraph>
      {node.skipped_due_to_quota && <span>(Skipped due to quota) </span>}
      <span style={paragraphStyle}>
        Intent detection
        {matchedIntent && (
          <>
            {' '}
            · <strong>{matchedIntent.name}</strong>
          </>
        )}
      </span>
    </Text.Paragraph>
  );
}
